module.exports = "https://cdn.thelire.com/ins/resource/ico_tab1_search@3x.509c175bbbe9934f94394d5b41011ce6.png";